import React from 'react';
import { Checkbox } from 'fronton-react';

import { FilterListCheckboxStyle, StyledLi } from './styles';

type FilterListItemProps = {
	topCategoryId: string | number;
	topCategoryName: string;
	checked: boolean;
	onClickHandler: (id: string | number) => void;
};

export const FilterListItem = ({
	topCategoryId,
	topCategoryName,
	checked,
	onClickHandler,
}: FilterListItemProps) => {
	const onClick = () => onClickHandler(topCategoryId);

	return (
		<StyledLi key={`filter-list-item-${topCategoryId}`} data-qa="filter-list-item">
			{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
			{/* @ts-ignore */}
			<Checkbox
				checked={checked}
				size="l"
				label={topCategoryName}
				className={FilterListCheckboxStyle}
				onChange={onClick}
			/>
		</StyledLi>
	);
};
